export default __webpack_public_path__ + "static/media/photo--sm--kara12.0d1852a4.jpg";